import { useEffect, useState } from 'react';
import Navbar from '@/components/layout/Navbar';
import Footer from '@/components/layout/Footer';
import Hero from '@/components/sections/Hero';
import About from '@/components/sections/About';
import Skills from '@/components/sections/Skills';
import Projects from '@/components/sections/Projects';
import Experience from '@/components/sections/Experience';
import GithubActivity from '@/components/sections/GithubActivity';
import Contact from '@/components/sections/Contact';
import { Button } from '@/components/ui/button';
import { ChevronUp } from 'lucide-react';

export default function Home() {
  console.log("Home component rendering");
  const [showScrollTop, setShowScrollTop] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setShowScrollTop(window.scrollY > 400);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

  return (
    <div className="flex flex-col min-h-screen">
      <Navbar />
      <main className="flex-grow">
        <Hero />
        <About />
        <Skills />
        <Projects />
        <Experience />
        <GithubActivity />
        <Contact />
      </main>
      <Footer />

      {/* Enhanced scroll-to-top button with animation effects */}
      {showScrollTop && (
        <div className="fixed bottom-8 right-8 z-50 animate-fade-in group">
          {/* Pulsing background effect */}
          <div className="absolute inset-0 bg-gradient-to-r from-primary to-secondary rounded-full opacity-30 group-hover:opacity-50 blur-md animate-pulse-subtle scale-125"></div>

          {/* Main button */}
          <Button
            size="icon"
            onClick={scrollToTop}
            className="relative w-14 h-14 rounded-full shadow-xl z-50 bg-background backdrop-blur-sm border border-primary/20 group-hover:border-primary/50 transition-all duration-300 group-hover:scale-110"
            aria-label="Scroll to top"
          >
            {/* Button inner glow */}
            <div className="absolute inset-0.5 bg-gradient-to-br from-primary/10 to-secondary/10 rounded-full opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>

            {/* Icon with animation */}
            <div className="relative z-10 transition-transform duration-300 transform group-hover:-translate-y-1">
              <ChevronUp className="h-5 w-5 text-primary group-hover:text-accent transition-colors duration-300" />
            </div>

            {/* Hint text */}
            <span className="absolute -bottom-8 left-1/2 transform -translate-x-1/2 text-xs font-medium text-muted-foreground opacity-0 group-hover:opacity-100 whitespace-nowrap transition-opacity duration-300">
              Back to Top
            </span>
          </Button>

          {/* Decorative particles */}
          <div className="absolute top-0 left-1/2 transform -translate-x-1/2 -translate-y-4 h-1 w-1 rounded-full bg-primary opacity-0 group-hover:opacity-70 transition-opacity duration-300 animate-float" style={{ animationDuration: '2s' }}></div>
          <div className="absolute top-1/4 right-0 transform translate-x-3 h-1 w-1 rounded-full bg-secondary opacity-0 group-hover:opacity-70 transition-opacity duration-300 animate-float animate-delay-200" style={{ animationDuration: '3s' }}></div>
          <div className="absolute bottom-0 left-0 transform -translate-x-2 translate-y-3 h-1.5 w-1.5 rounded-full bg-accent opacity-0 group-hover:opacity-70 transition-opacity duration-300 animate-float animate-delay-300" style={{ animationDuration: '2.5s' }}></div>
        </div>
      )}
    </div>
  );
}